import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { NewQuotePage } from '@/pages/quotes/new/NewQuotePage'

const NewQuoteSearchSchema = z.object({
  clientId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_dashboard/quotes/new/')({
  validateSearch: NewQuoteSearchSchema,
  component: NewQuotePage,
})
